export default __webpack_public_path__ + "static/media/rating-2.8a4eedba.webp";